import React, { useEffect, useState } from "react";
import girlImage from "../assets/girl_1.webp";
import BuddhaIcon from "../assets/buddha_icon_1.webp";
import LoadingComponent from "./LoadingComponent";
import SocialMediaSection from "./SocialMediaSection";
import "./Footer.css";

const Footer = () => {
  const [shop, setShop] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchShopData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/controllers/fetch_footer.php?id=1`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const { data } = await response.json();
        setShop(data);
      } catch (error) {
        console.error("Error fetching shop data:", error);
        setError(error.message);
      }
    };

    fetchShopData();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!shop) {
    return (
      <div>
        <LoadingComponent />
      </div>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-heading mb-3">Besöksadress</h3>
          <p className="footer-text">{shop.shop_name}</p>
          <p className="footer-text">{shop.address_line1}</p>
          {shop.address_line2 && (
            <p className="footer-text">{shop.address_line2}</p>
          )}
          <p className="footer-text">{`${shop.postal_code} ${shop.city}`}</p>
        </div>
        <div className="footer-column">
          <h3 className="footer-heading mb-3">Kontaktuppgifter</h3>
          <p className="footer-text">{shop.contact_person}</p>
          <p className="footer-text">{shop.telephone}</p>
          <p className="footer-text">
            <a href={`mailto:${shop.email}`} className="footer-link">
              {shop.email}
            </a>
          </p>
        </div>
        {(shop.facebook || shop.instagram || shop.twitter || shop.tiktok) && (
          <div className="footer-column">
            <h3 className="footer-heading mb-3">Följ oss på</h3>
            <SocialMediaSection
              facebook={shop.facebook}
              instagram={shop.instagram}
              twitter={shop.twitter}
              tiktok={shop.tiktok}
            />
          </div>
        )}
      </div>
      <div className="footer-quirky">
        <p className="quirky-text">Tack för att ni besöker oss!</p>
        <span role="img" aria-label="Relaxing" className="quirky-icon">
          <img
            src={BuddhaIcon}
            alt="Relaxing Icon"
            style={{ height: "48px" }}
          />
        </span>
      </div>
      <img
        src={girlImage}
        alt="Decorative girl"
        className="footer-girl-image"
      />
      <div className="footer-credits">
        <p>
          Webbsida skapad av{" "}
          <a href="mailto:stevelyne1971@gmail.com" className="footer-link">
            Steven Lyne
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
